import React, { useState } from 'react';
import { FaEdit, FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const ProjectStatus = () => {
  const [view, setView] = useState('current'); // 'current' or 'previous'
  const [searchTerm, setSearchTerm] = useState('');
  const [sortKey, setSortKey] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const [isModalOpen, setIsModalOpen] = useState(false); // For showing modal
  const [editProject, setEditProject] = useState(null); // To store project to be edited

  const [currentProjects, setCurrentProjects] = useState([
    { id: 1, producer: 'John Doe', productionName: 'Film A', workDescription: 'Shooting scenes', status: 'In Progress' },
    { id: 2, producer: 'Jane Smith', productionName: 'Commercial B', workDescription: 'Editing video', status: 'In Review' },
    { id: 3, producer: 'Alice Johnson', productionName: 'TV Show C', workDescription: 'Script writing', status: 'Pending' },
  ]);

  const previousProjects = [
    { id: 1, producer: 'John Doe', productionName: 'Film X', workDescription: 'Post-production', completionDate: '2024-09-15', status: 'Done' },
    { id: 2, producer: 'Jane Smith', productionName: 'Commercial Y', workDescription: 'Final cut', completionDate: '2024-08-20', status: 'Done' },
  ];

  const filteredAndSortedProjects = (projects) => {
    let filteredProjects = projects.filter(
      (project) =>
        project.producer.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.productionName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (sortKey) {
      filteredProjects = filteredProjects.sort((a, b) => {
        let aValue = a[sortKey];
        let bValue = b[sortKey];

        if (sortKey === 'completionDate') {
          aValue = new Date(aValue);
          bValue = new Date(bValue);
        }

        return sortOrder === 'asc' ? (aValue > bValue ? 1 : -1) : (aValue < bValue ? 1 : -1);
      });
    }

    return filteredProjects;
  };

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortOrder('asc');
    }
  };

  const handleStatusChange = (id, newStatus) => {
    const updatedProjects = currentProjects.map((project) =>
      project.id === id ? { ...project, status: newStatus } : project
    );
    setCurrentProjects(updatedProjects);
  };

  const openModal = (project = null) => {
    setEditProject(project);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditProject(null);
  };

  const handleSaveProject = (e) => {
    e.preventDefault();
    const { producer, productionName, workDescription, status } = e.target.elements;

    const newProject = {
      id: editProject ? editProject.id : currentProjects.length + 1,
      producer: producer.value,
      productionName: productionName.value,
      workDescription: workDescription.value,
      status: status.value,
    };

    if (editProject) {
      const updatedProjects = currentProjects.map((project) =>
        project.id === editProject.id ? newProject : project
      );
      setCurrentProjects(updatedProjects);
    } else {
      setCurrentProjects([...currentProjects, newProject]);
    }

    closeModal();
  };

  return (
    <>
    <SEO
      title="Project Collaboration"
      description="Collaborate on film projects with your team in real time using ProducerBuddy's project collaboration tools."
      url="https://producerbuddy.pilomation.com/project-collab"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div className='flex gap-3'>
    {/* Sidebar */}
    <div className="w-64 bg-gray-800 text-white p-5 space-y-6">
        <h1 className="text-2xl p-2 font-bold"><Link to='/marketing-agencies'>Marketing Dashboard</Link></h1>
        <nav>
          <ul className="space-y-4 mt-4">
            <li className="hover:text-yellow-400"><Link to='/marketing-tracker'>Campaign Management</Link></li>
            <li className="hover:text-yellow-400"><Link to='/marketing-collaborations'>Production Collabs</Link></li>
            <li className="hover:text-yellow-400"><Link to='/market-analysis'>Analytics</Link></li>
            <li className="hover:text-yellow-400">Clients</li>
            <li className="hover:text-yellow-400">Team</li>
          </ul>
        </nav>
      </div>
    <div className="container mx-auto py-10 p-4">
      {/* Navbar */}
      <div className="flex justify-between items-center mb-6">
        <nav className="flex text-center space-x-4">
          <button className={`text-lg ${view === 'current' ? 'font-bold' : ''}`} onClick={() => setView('current')}>Current Projects</button>
          <button className={`text-lg ${view === 'previous' ? 'font-bold' : ''}`} onClick={() => setView('previous')}>Previous Projects</button>
        </nav>

        {/* Search Bar */}
        <div className="flex items-center border border-gray-300 rounded-lg p-2">
          <input
            type="text"
            className="outline-none"
            placeholder="Search by producer or production name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <FaSearch className="text-gray-500 ml-2" />
        </div>
      </div>

      {/* Project Table */}
      {view === 'current' ? (
        <div className="overflow-x-auto">
            <div className='flex justify-between'>
                <h2 style={{fontSize:'32px'}} >Current projects</h2>
                <button className='bg-green-600 text-white p-2' onClick={() => openModal()}>Add Collabs</button>
            </div>
          <table className="table-auto w-full bg-white shadow-md rounded-lg">
            <thead>
              <tr className="bg-gray-200 text-left text-gray-600 uppercase text-sm">
                <th className="py-3 px-4 cursor-pointer" onClick={() => handleSort('producer')}>Producer {sortKey === 'producer' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}</th>
                <th className="py-3 px-4 cursor-pointer" onClick={() => handleSort('productionName')}>Production Name {sortKey === 'productionName' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}</th>
                <th className="py-3 px-4">Work Description</th>
                <th className="py-3 px-4 cursor-pointer" onClick={() => handleSort('status')}>Status {sortKey === 'status' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}</th>
                <th className="py-3 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredAndSortedProjects(currentProjects).map((project) => (
                <tr key={project.id} className="border-b">
                  <td className="py-3 px-4">{project.producer}</td>
                  <td className="py-3 px-4">{project.productionName}</td>
                  <td className="py-3 px-4">{project.workDescription}</td>
                  <td className="py-3 px-4">
                    <select
                      value={project.status}
                      onChange={(e) => handleStatusChange(project.id, e.target.value)}
                      className="bg-white border border-gray-300 p-2 rounded-lg"
                    >
                      <option value="Pending">Pending</option>
                      <option value="In Progress">In Progress</option>
                      <option value="In Review">In Review</option>
                      <option value="Done">Done</option>
                    </select>
                  </td>
                  <td className="py-3 px-4">
                    <button onClick={() => openModal(project)}>
                      <FaEdit className="text-blue-500 hover:text-blue-700" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <h2 style={{fontSize:'32px'}} >Previous projects</h2>
          <table className="table-auto w-full bg-white shadow-md rounded-lg">
            <thead>
              <tr className="bg-gray-200 text-left text-gray-600 uppercase text-sm">
                <th className="py-3 px-4">Producer</th>
                <th className="py-3 px-4">Production Name</th>
                <th className="py-3 px-4">Work Description</th>
                <th className="py-3 px-4">Completion Date</th>
                <th className="py-3 px-4">Status</th>
              </tr>
            </thead>
            <tbody>
              {previousProjects.map((project) => (
                <tr key={project.id} className="border-b">
                  <td className="py-3 px-4">{project.producer}</td>
                  <td className="py-3 px-4">{project.productionName}</td>
                  <td className="py-3 px-4">{project.workDescription}</td>
                  <td className="py-3 px-4">{project.completionDate}</td>
                  <td className="py-3 px-4">{project.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal for Adding/Editing Projects */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-5 shadow-md w-96">
            <h2 className="text-lg font-semibold mb-4">{editProject ? 'Edit Project' : 'Add Project'}</h2>
            <form onSubmit={handleSaveProject}>
              <input
                type="text"
                name="producer"
                placeholder="Producer"
                defaultValue={editProject ? editProject.producer : ''}
                required
                className="border border-gray-300 rounded-lg p-2 mb-4 w-full"
              />
              <input
                type="text"
                name="productionName"
                placeholder="Production Name"
                defaultValue={editProject ? editProject.productionName : ''}
                required
                className="border border-gray-300 rounded-lg p-2 mb-4 w-full"
              />
              <input
                type="text"
                name="workDescription"
                placeholder="Work Description"
                defaultValue={editProject ? editProject.workDescription : ''}
                required
                className="border border-gray-300 rounded-lg p-2 mb-4 w-full"
              />
              <select
                name="status"
                defaultValue={editProject ? editProject.status : 'Pending'}
                className="border border-gray-300 rounded-lg p-2 mb-4 w-full"
              >
                <option value="Pending">Pending</option>
                <option value="In Progress">In Progress</option>
                <option value="In Review">In Review</option>
                <option value="Done">Done</option>
              </select>
              <div className="flex justify-between">
                <button
                  type="button"
                  onClick={closeModal}
                  className="bg-gray-500 text-white py-2 px-4 rounded-lg"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 text-white py-2 px-4 rounded-lg"
                >
                  {editProject ? 'Save Changes' : 'Add Project'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
    </div>
    </>
    
  );
};

export default ProjectStatus;

